var _defs, _sodipodiNamedview;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevicesRed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: 528.42981,
    width: 562.97363,
    id: "Layer_1",
    viewBox: "0 0 345.891 324.66728",
    xmlSpace: "preserve",
    sodipodidocname: "devices_red.svg",
    inkscapeversion: "1.2.1 (9c6d41e4, 2022-07-14)",
    xmlnsinkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnssodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnssvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs12224"
  })), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview12222",
    pagecolor: "#ffffff",
    bordercolor: "#000000",
    borderopacity: 0.25,
    inkscapeshowpageshadow: 2,
    inkscapepageopacity: 0,
    inkscapepagecheckerboard: 0,
    inkscapedeskcolor: "#d1d1d1",
    showgrid: "false",
    inkscapezoom: 1.28375,
    inkscapecx: 379.35735,
    inkscapecy: 332.2298,
    "inkscapewindow-width": 2651,
    "inkscapewindow-height": 1149,
    "inkscapewindow-x": 237,
    "inkscapewindow-y": 25,
    "inkscapewindow-maximized": 0,
    "inkscapecurrent--layer": "Layer_1"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#fc0000",
      strokeWidth: 2.29979,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "g12551-5",
    transform: "matrix(4.0073295,0,0,4.0073295,124.85755,231.89802)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    stroke: "#1c274c",
    strokeWidth: 1.5,
    id: "circle12539-3",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#fc0000",
      strokeWidth: 2.29979,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m 17.2994,10.064237 1.9273,0.315 c 0.1579,0.0258 0.2736,0.1621 0.2733,0.3219 v 1.7934 c 0,0.1582 -0.1135,0.2938 -0.2697,0.3212 l -1.9299,0.3388 c -0.1119,0.3868 -0.2655,0.7592 -0.4589,1.1113 l 1.1408,1.5839 c 0.0936,0.1297 0.0789,0.3081 -0.034,0.4213 l -1.2679,1.2688 c -0.1122,0.1118 -0.2883,0.1278 -0.4181,0.0362 l -1.5996,-1.1221 c -0.3528,0.1963 -0.7275,0.3528 -1.1185,0.4679 l -0.3408,1.9207 c -0.0274,0.1555 -0.1628,0.269 -0.3209,0.269 h -1.7937 c -0.1594,0 -0.2954,-0.1151 -0.3212,-0.272 l -0.3183,-1.9112 c -0.3903,-0.1128 -0.767,-0.2683 -1.12345,-0.4643 l -1.58818,1.1123 c -0.12946,0.091 -0.30589,0.0753 -0.41775,-0.0365 l -1.26794,-1.2688 c -0.11251,-0.1132 -0.12718,-0.2909 -0.03457,-0.4204 l 1.12217,-1.5694 c -0.19795,-0.3581 -0.35514,-0.736 -0.46896,-1.1283 l -1.90157,-0.3372 C 4.61349,12.788037 4.5,12.652737 4.5,12.494537 v -1.7934 c 0,-0.1592 0.11544,-0.2955 0.27263,-0.3216 l 1.90158,-0.3166 C 6.78868,9.6697375 6.94586,9.2917575 7.14316,8.9346875 L 6.0347,7.3489275 c -0.09099,-0.12946 -0.07533,-0.30554 0.03652,-0.41739 l 1.26761,-1.2675 c 0.11317,-0.1125 0.29025,-0.1275 0.42037,-0.03457 l 1.57513,1.125 c 0.35384,-0.19369 0.72957,-0.34793 1.12087,-0.46043 l 0.3118,-1.90891 c 0.0257,-0.15783 0.162,-0.27359 0.3218,-0.27359 h 1.7937 c 0.1585,0 0.2938,0.11413 0.3212,0.27 l 0.3362,1.91935 c 0.3891,0.11315 0.7641,0.26902 1.1192,0.46532 l 1.5794,-1.1351 c 0.1298,-0.09359 0.3079,-0.07892 0.421,0.03391 l 1.2683,1.2675 c 0.1119,0.11217 0.1275,0.28859 0.0365,0.41804 l -1.1251,1.60337 c 0.1931,0.35185 0.3473,0.72361 0.4602,1.1103095 z m -7.58215,1.5473 c 0,1.2607 1.02205,2.2826 2.28285,2.2826 1.2607,0 2.2828,-1.0219 2.2828,-2.2826 0,-1.2606 -1.0221,-2.2825795 -2.2828,-2.2825795 -1.2608,0 -2.28285,1.0219795 -2.28285,2.2825795 z",
    stroke: "#000000",
    id: "path12383",
    style: {
      fill: "none",
      stroke: "#fc0000",
      strokeWidth: 1.06862,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(2.1521109,0,0,2.1521109,-13.82533,-65.56706)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#fc0000",
      strokeWidth: 1.06862,
      strokeLinecap: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 12,31.395716 11.98565,19.111538",
    id: "path13204",
    transform: "matrix(2.1521109,0,0,2.1521109,-13.82533,-65.56706)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#fc0000",
      strokeWidth: 1.06862,
      strokeLinecap: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 26.872564,31.395716 V 25.253628 H 11.992826 l -14.8653888,-10e-7 v 6.142088",
    id: "path13221",
    transform: "matrix(2.1521109,0,0,2.1521109,-13.82533,-65.56706)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    stroke: "#1c274c",
    strokeWidth: 1.5,
    id: "circle12539",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#fc0000",
      strokeWidth: 2.29979,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(-32.007403)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8.5,12.5 2,2 5,-5",
    stroke: "#1c274c",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path12541",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#fc0000",
      strokeWidth: 2.29979,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(-32.007403)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    stroke: "#1c274c",
    strokeWidth: 1.5,
    id: "circle12539-3-8",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#fc0000",
      strokeWidth: 2.29979,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(32.007403)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8.5,12.5 2,2 5,-5",
    stroke: "#1c274c",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path12541-3-5",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#fc0000",
      strokeWidth: 2.29979,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(32.007403)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8.5,12.5 2,2 5,-5",
    stroke: "#1c274c",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path12541-3",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#fc0000",
      strokeWidth: 2.29979,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevicesRed);
export default __webpack_public_path__ + "static/media/devices_red.88e233a4.svg";
export { ForwardRef as ReactComponent };